var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "index-progress-bar" }, [
      _c("li", { staticClass: "is-complete" }, [
        _c("span", [_vm._v("001 - Order Created")])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "is-active" }, [
        _c("span", [_vm._v("100 - Lab Received")])
      ]),
      _vm._v(" "),
      _c("li", {}, [_c("span", [_vm._v("300 - Sequencing")])]),
      _vm._v(" "),
      _c("li", {}, [_c("span", [_vm._v("500 - Analysing")])]),
      _vm._v(" "),
      _c("li", {}, [_c("span", [_vm._v("600 - Detailed Analysis")])]),
      _vm._v(" "),
      _c("li", {}, [_c("span", [_vm._v("800 - Pending Approval")])]),
      _vm._v(" "),
      _c("li", {}, [_c("span", [_vm._v("900 - Completed")])])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62350ebe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62350ebe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressTimeline.vue
// module id = null
// module chunks = 